export default __webpack_public_path__ + "static/media/circle.3ff27fbc.png";